import { FC } from 'react'
import { useTranslation } from '../../../../hooks/locale'
import { Card, TipsList, TipItem, TipLink, Heading, Text, TipsText } from './styles'
import { SRLNoResultTransport } from '../../../../transports/srl-objects-response-transport'

interface ListingNoDataProps {
    srlNoResult: SRLNoResultTransport
}

const ListingNoData: FC<ListingNoDataProps> = ({ srlNoResult }) => {
    const { t } = useTranslation()

    const regionWithoutFilterTitle = srlNoResult?.regionWithoutFilter?.title || t('region')
    const regionWithoutFilterLink = srlNoResult?.regionWithoutFilter?.link?.url

    const parentRegionTitle = srlNoResult?.parentRegion?.title || t('region')
    const parentRegionLink = srlNoResult?.parentRegion?.link?.url

    return (
        <Card>
            <Heading>{t('no-listings.heading')}</Heading>
            <Text>{t('no-listings.subheading', { region: regionWithoutFilterTitle })}</Text>
            <TipsText>{t('no-listings.tips')}:</TipsText>
            <TipsList>
                {regionWithoutFilterLink && (
                    <TipItem>
                        <TipLink href={regionWithoutFilterLink} noCrawl>
                            {t('no-listings.without-params', { region: regionWithoutFilterTitle })}
                        </TipLink>
                    </TipItem>
                )}
                {parentRegionLink && (
                    <TipItem>
                        <TipLink href={parentRegionLink} noCrawl>
                            {t('no-listings.in-parent-region', { region: parentRegionTitle })}
                        </TipLink>
                    </TipItem>
                )}
                <TipItem>
                    <TipLink href="/">{t('no-listings.new-search')}</TipLink>
                </TipItem>
            </TipsList>
        </Card>
    )
}

export default ListingNoData
